export const CANCELLED_ROUTE_ERROR_MESSAGE = "Cancel rendering route";

// Query keys that may follow a post-login / post-checkout redirect. Anything
// else stays on the current page so leftover `router.query` cannot taint the
// URL we push (UTM/GCLID are copied separately from the router).
export const REDIRECT_QUERY_PARAM_ALLOWLIST = [
  "plan",
  "ai",
  "migration-id",
  "migration-source-plan",
] as const;
